import { Button, required, TextInput, useNotify } from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import Edit from "@mui/icons-material/Edit";
import { studentRequests } from "api/studentApi";
import dataProvider from "server/dataProvider";

const HealthInsuranceNumberModal = ({ record, healthInsurance, fetchHealthInsurance }) => {
  const notify = useNotify();

  const handleSubmit = async formData => {
    await dataProvider.customRequest(
      studentRequests.getStudentHealthInsurance(record?.studentId),
      { healthInsuranceNumber: formData?.healthInsuranceNumber },
      "PATCH",
    );
    fetchHealthInsurance();
    notify("Успешна редакция на номер на здравно осигуряване", { type: "success" });
  };

  return (
    <FormModal
      titleContent="Редакция на номер на здравно осигуряване"
      onConfirm={handleSubmit}
      defaultValues={healthInsurance}
      triggerButton={
        <Button
          label="Редакция"
          variant="contained"
          startIcon={<Edit />}
        />
      }
    >
      <TextInput
        label="Номер на здравно осигуряване"
        source="healthInsuranceNumber"
        validate={required()}
        fullWidth
      />
    </FormModal>
  );
};

export default HealthInsuranceNumberModal;
